/* eslint-disable jsx-a11y/iframe-has-title */
import "../assets/css/page/locations.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { FaLocationPin, FaPhone } from "react-icons/fa6";

const location1 = {
  address: "14234 Smoketown Rd, Woodbridge, VA 22192",
  phoneNumber: "(703)490-3112 / (571)491-9196",
  mapSrc:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3191180.8666582485!2d-77.30122874836948!3d38.63996798437784!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6566cc84fe667%3A0x36c3ab9431294c53!2sKadi's%20Hair%20Gallery!5e0!3m2!1sen!2sus!4v1712335583165!5m2!1sen!2sus",
};

const Locations = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{"Kadi's Hair Gallery - Locations"}</title>
        </Helmet>
      </HelmetProvider>

      <section className="main-locations">
        <h2 data-aos="fade-zoom">Store Location</h2>

        <div id="locations" className="container">
          <div className="location-card">
            <h3 className="h3" data-aos="fade-left">
              Kadi&apos;s Hair Gallery
            </h3>

            <div className="locations-details">
              <p>
                <FaLocationPin style={{ marginRight: "6px" }} />
                {location1.address}
              </p>
              <p>
                <FaPhone style={{ marginRight: "6px" }} />
                {location1.phoneNumber}
              </p>
            </div>

            <div className="map-container">
              <iframe
                src={location1.mapSrc}
                width="100%"
                height="400"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Locations;